import { Calendar } from '../../../assets/icons/Calendar';
import { DollarSmall } from '../../../assets/icons/DollarSmall';
import { WashingMachineSmall } from '../../../assets/icons/WashingMachineSmall';
import { Wrench } from '../../../assets/icons/Wrench';
import { ConfirmationPanel } from '../ConfirmationPage.types';

const formatPayment = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatPurchasedPlan = (
  brand: string,
  appliance?: string,
  startDate?: string,
  planNumber?: string,
  netFirstPaymentAmount?: number,
  netFirstPaymentAmountAfterPromotionalPeriod?: number,
  discountTerm?: number,
): ConfirmationPanel | undefined => {
  if (!brand || !appliance || !startDate || !planNumber || netFirstPaymentAmount === undefined) {
    return undefined;
  }

  const formattedNetFirstPaymentAmount = formatPayment.format(netFirstPaymentAmount);
  const formattedPaymentAmountAfterPromotionalPeriod = netFirstPaymentAmountAfterPromotionalPeriod
    ? formatPayment.format(netFirstPaymentAmountAfterPromotionalPeriod)
    : undefined;

  const afterDiscountPayments = {
    label: `Monthly Payment (after ${discountTerm} months)`,
    icon: DollarSmall(),
    value: String(formattedPaymentAmountAfterPromotionalPeriod),
  };

  const data = [
    {
      label: 'Appliance',
      icon: WashingMachineSmall(),
      value: `${brand} ${appliance}`,
    },
    {
      label: 'Plan number',
      icon: Wrench(),
      value: planNumber,
    },
    {
      label: 'Plan start date',
      icon: Calendar(),
      value: startDate,
    },
    {
      label: `Monthly Payment ${discountTerm ? `(first ${discountTerm} months)` : ''}`,
      icon: DollarSmall(),
      value: String(formattedNetFirstPaymentAmount),
    },
    ...(discountTerm && formattedPaymentAmountAfterPromotionalPeriod
      ? [afterDiscountPayments]
      : []),
  ];

  return {
    panelType: 'purchasePlan',
    panelTitle: 'Plan details',
    data,
  };
};

export const formatRegistrationData = (
  brand: string,
  appliance?: string,
  modelNumber?: string,
  serialNumber?: string,
  purchaseDate?: string,
  warrantyLength?: number,
): ConfirmationPanel | undefined => {
  if (
    ![brand, appliance, modelNumber, serialNumber, purchaseDate].every(
      (value) => typeof value === 'string' && value.trim() !== '',
    )
  ) {
    return undefined;
  }

  return {
    panelType: 'registration',
    panelTitle: 'Registration details',
    data: [
      {
        label: 'Appliance',
        icon: WashingMachineSmall(),
        value: `${brand} ${appliance}`,
      },
      {
        label: 'Manufacturer warranty length',
        icon: WashingMachineSmall(),
        value: `${warrantyLength} months`,
      },
      {
        label: 'Model number',
        icon: Wrench(),
        value: modelNumber,
      },
      {
        label: 'Serial number',
        icon: Wrench(),
        value: serialNumber,
      },
      {
        label: 'Arrival date',
        icon: Calendar(),
        value: purchaseDate,
      },
    ],
  };
};
